import React from "react";
import ResearchBanner from "../Components/ResearchComponents/ResearchBanner";
import "../Components/ResearchComponents/Research.css";
import ResearchSummary from "../Components/ResearchComponents/ResearchSummary";
import { Helmet } from "react-helmet";
const Research = () => {
  return (
    <>
      <Helmet>
        {/* Meta tags */}
        <title>
          Diamond Research & Analysis | Sreehari Diamond Laboratory{" "}
        </title>
        <meta
          name="description"
          content="We conduct in-depth diamond and gemstone research to advance gemological knowledge and improve testing and certification accuracy."
        />
        <meta
          name="keywords"
          content="lab grown diamond certification, best diamond certification in india, Gemstone Identification Lab, Diamond, Gemological Laboratory, Diamond Testing Lab, Diamond Sealing service, Diamond Hologram Stickers, Hologram Stickers for Certificates, Best diamond online services, deep research of diamond"
        />
        {/* OG tags */}
        <meta
          property="og:title"
          content="Diamond Research & Analysis | Sreehari Diamond Laboratory"
        />
        <meta
          property="og:description"
          content="We conduct in-depth diamond and gemstone research to advance gemological knowledge and improve testing and certification accuracy."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://sreeharidiamondlab.com/research"
        />
        <meta
          property="og:image"
          content="https://sreeharidiamondlab.com/static/media/Research.63521a7a187cb94af1c7.webp
"
        />
        <meta property="og:site_name" content="sreehari diamond laboratory" />
        {/* Twitter tags */}
        <meta
          name="twitter:title"
          content="Diamond Research & Analysis | Sreehari Diamond Laboratory"
        />
        <meta
          name="twitter:description"
          content="We conduct in-depth diamond and gemstone research to advance gemological knowledge and improve testing and certification accuracy."
        />
        <meta
          name="twitter:image"
          content="https://sreeharidiamondlab.com/static/media/Research.63521a7a187cb94af1c7.webp
"
        />
        <meta name="twitter:site" content="sreehari diamond laboratory" />
        <link
          rel="canonical"
          href="https://sreeharidiamondlab.com/research"
        />{" "}
      </Helmet>
      <div>
        <ResearchBanner />
        <ResearchSummary />
      </div>
    </>
  );
};

export default Research;
